/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Current account state for flex market subscription
 */
export type FlexMarketSubscriptionState =
  (typeof FlexMarketSubscriptionState)[keyof typeof FlexMarketSubscriptionState]

export const FlexMarketSubscriptionState = {
  notEligible: "notEligible",
  eligible: "eligible",
  active: "active",
  activeNoAssets: "activeNoAssets",
  unknown: "unknown",
} as const
